import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import ScrollToTop from "./components/base/ScrollToTop";
import FloatingCTA from "./components/feature/FloatingCTA";

import { ToastProvider } from "./hooks/useToast";

function AppLayout() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard/");
  return (
    <div className="min-h-screen flex flex-col">
      {!isDashboard && <Navbar />}
      <main className="flex-1">
        <AppRoutes />
      </main>
      {!isDashboard && <Footer />}
      {!isDashboard && <FloatingCTA />}
    </div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ToastProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <AppLayout />
        </BrowserRouter>
      </ToastProvider>
    </I18nextProvider>
  );
}

export default App;
